var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46882 2.0625L6.52114 6.11482L6.4474 3.08515C6.44354 2.9265 6.56898 2.79478 6.72762 2.79092C6.88606 2.78706 7.01789 2.91239 7.02185 3.07113L7.10595 6.53123C7.10585 6.68469 7.04623 6.82902 6.93766 6.93759C6.82918 7.04606 6.68476 7.10578 6.52439 7.10568L3.0712 7.02158C2.99442 7.01976 2.92545 6.98797 2.87508 6.93759C2.82145 6.88396 2.78895 6.80921 2.79098 6.72735C2.79484 6.56871 2.92647 6.44338 3.08511 6.44724L6.12128 6.52747L2.06256 2.46875C1.95044 2.35663 1.95044 2.17462 2.06256 2.0625C2.17469 1.95037 2.35669 1.95037 2.46882 2.0625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendArrowDown);
export default __webpack_public_path__ + "static/media/trend-arrow-down.ca8b2fbd65fd085a26f2b60752086c6f.svg";
export { ForwardRef as ReactComponent };